import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import DidsContainer from "../../components/Admin/Dids/DidsContainer";
import UserDidsList from "../../components/Admin/Dids/UserDidsList";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import AddAutoReplyRules from "../../components/Admin/addAutoReplyRules";
import DidInformation from "../../components/Admin/Dids/DidInformation";
import { Did } from "../../interfaces/Did.type";


const rowStyle: React.CSSProperties = {
    height: "100%",
    width: "100%",
};

const ScrollableCol = styled(Col)`
    height: 100%;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 2px; 
        opacity: 0;
        transition: opacity 0.2s;
    }

    &:hover::-webkit-scrollbar {
        opacity: 1;
    }
`;

const DidsPage = () => {

    const [selectedDid, setSelectedDid] = useState<Did | null>(null);
    const { selectedView, selectedAccount } = useSelector((state: RootState) => state.admin)



    useEffect(() => {
        setSelectedDid(null)
    }, [selectedAccount])


    return (
        <Row style={rowStyle}>
            <ScrollableCol span={5}>
                <DidsContainer selectedDid={selectedDid} setSelectedDid={setSelectedDid} />
            </ScrollableCol>
            <Col style={{ height: "100%" }} span={19}>
                {
                    selectedDid && selectedView === "userDids" &&
                    <>
                        <UserDidsList selectedAccount={selectedAccount} selectedDid={selectedDid.did} />
                    </>
                }
                {
                    selectedDid && selectedView === "rules" &&
                    <>
                        <AddAutoReplyRules did={selectedDid.did} />
                    </>
                }
                {
                    selectedDid && (selectedView === "" || selectedView === "info") &&
                    <>
                        <DidInformation selectedAccount={selectedAccount} setSelectedDid={setSelectedDid} did={selectedDid} />
                    </>
                }
            </Col>
        </Row>
    );
};

export default DidsPage;